export default __webpack_public_path__ + "static/media/driving-licence-back.9ac8f46b.jpg";